// @flow strict
import { Table } from 'antd';
import * as React from 'react';
import SingleReferer from './SingleReferer';
import "./Referrals.css"; // Add a CSS file for better styling

function Referrals({ referralUsers }) {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 500);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 500);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const columns = [
    {
      title: "Name",
      dataIndex: "fname",
      key: "fname",
      align: "center",
      render: (_, item) => <p>{item?.referer?.fname + " " + item.referer?.lname}</p>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      align: "center",
      render: (_, item) => <p>{item?.referer?.email}</p>,
    },
    {
      title: "Refer Count",
      dataIndex: "users",
      key: "users",
      align: "center",
      render: (_, item) => <p>{item?.users?.length}</p>,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      align: "center",
      render: (_, item) => <SingleReferer item={item} />,
    },
  ];

  return (
    <div className="referrals-container">
      <div className="table-header">
        <h3 className="table-title">User Referral List</h3>
      </div>
      <Table
        dataSource={referralUsers}
        columns={columns}
        // loading={fetching}
        bordered
        scroll={isMobile ? { x: 500 } : undefined} 
      />
    </div>
  );
}

export default Referrals;
